import React from "react";

export default function Footer({ children }) {
  return <footer className="footer">{children}</footer>;
}
